module.exports = __webpack_public_path__ + "Ecology-and-Evolution---2019-Mech---Evolutionary-history-predicts-high-impact-invasions-by-herbivorous-insects.pdf";